import React from 'react'
import { ITestimonialLink as IContentfulTestimonialLink } from 'marketing-site/@types/generated/contentful'
import EntryMarker from 'marketing-site/src/components/common/EntryMarker'
import { TestimonialLink } from 'marketing-site/src/library/elements/TestimonialLink'
import { transformImage } from '../elements/ContentfulImage'

export const ContentfulTestimonialLink = (testimonialTextOnly: IContentfulTestimonialLink) => (
  <EntryMarker entry={testimonialTextOnly}>
    <TestimonialLink {...transformTestimonialLink(testimonialTextOnly)} />
  </EntryMarker>
)

export function transformTestimonialLink({ fields }: IContentfulTestimonialLink) {
  return {
    ...fields,
    image: transformImage(fields.image),
  }
}
